// Shared display-formatting helpers for the Token Usage page/components.
import type { ModelUsageStat } from '../../types/tokenusage';

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/** Compact, locale-aware integer formatting (e.g. "841,526,840,345"). */
export function formatCount(n: number): string {
  return n.toLocaleString('en-US');
}

/** Human-friendly abbreviation for large token counts (e.g. "841.5B"). */
export function formatCompact(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 1_000_000_000) return `${(n / 1_000_000_000).toFixed(1)}B`;
  if (abs >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return formatCount(n);
}

/** "yyyy-MM" -> "July 2026" */
export function formatPeriodLabel(period: string): string {
  const [yearStr, monthStr] = period.split('-');
  const year = Number(yearStr);
  const month = Number(monthStr);
  if (!year || !month || month < 1 || month > 12) return period;
  return `${MONTH_NAMES[month - 1]} ${year}`;
}

export function periodKey(year: number, month: number): string {
  return `${year}-${String(month).padStart(2, '0')}`;
}

export function monthName(month: number): string {
  return MONTH_NAMES[month - 1] ?? String(month);
}

export const emptyStat: ModelUsageStat = { totalTokens: 0, requests: 0 };

export function isZeroUsage(stat: ModelUsageStat | undefined | null): boolean {
  return !stat || (stat.totalTokens === 0 && stat.requests === 0);
}
